import React from 'react';
import { Divider, Typography } from '@mui/material';
import khesariDal from '../../../../../images/Agri-info/crops/kheasirdal_খেসারী.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const KhesariDalInfo = () => {

    // dynamic title
    useDocumentTitle("খেসারী");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                খেসারী
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={khesariDal} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>ভূমিকা:</b><br /> পূর্ণবয়স্ক পোকা ও কীড়া উভয়ই গুদামজাত ডালের ক্ষতি করে থাকে।</p>
                            <p className="card-text"><b>ক্ষতির নমুনা:</b><br /> এ পোকা ডালের খোসা ছিদ্র করে ভিতরে ঢুকে শাঁস খেতে থাকে। ফলে দানা হাল্কা হয়ে যায়। এর ফলে বীজের অঙ্কুরোদগম ক্ষমতা নষ্ট হয়ে যায় এবং খাওয়ার অনুপযুক্ত হয়ে পড়ে।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>জাত পরিচিতি: <br />বারি খেসারী-১ জাত</b><br />স্থানীয় জাতের তুলনায় ৪০% পর্যন্ত বেশি ফলন দেয়। এ জাতের গাছ গাঢ় সবুজ এবং প্রচুর শাখা-প্রশাখা হয়ে থাকে। বারি খেসারী-১ জাতের হাজার বীজের ওজন ৪৮-৫২ গ্রাম। ফসল পাকতে ১২৫-১৩০ দিন সময় লাগে। ফলন হেক্টরপ্রতি ১.৪-১.৬ টন। এ জাত পাউডারি ও ডাউনী মিলডিউ রোগ প্রতিরোধী। </p>
                <p className="card-text"><b>সার ব্যবস্থাপনা:</b><br />খেসারীর রিলে ফসলের ক্ষেত্রে সারের প্রয়োজন হয় না। একক ফসলের জন্য অনুর্বর জমিতে হেক্টরপ্রতি নিম্নরূপ হারে সার ব্যবহার করতে হবে।</p>
                <div className='d-flex g-0'>
                    <div className='col'>
                        <p><b>সারের নাম </b></p>
                        <p>ইউরিয়া</p>
                        <p>টিএসপি</p>
                        <p>এমওপি</p>
                        <p>অণুজীব সার</p>
                    </div>
                    <div className='col-10'>
                        <p><b>সারের পরিমাণ/হেক্টর</b></p>
                        <p>৪০-৪৫ কেজি</p>
                        <p>৮০-৮৫ কেজি</p>
                        <p>২৩০-৪০ কেজি</p>
                        <p>সুপারিশ মত</p>
                    </div>
                </div>
                <p className="card-text"><b>সমুদয়</b><br />সার শেষ চাষের সময় প্রয়োগ করতে হবে। আগে খেসারীর চাষ না করা জমিতে আবাদের জন্য প্রতি কেজি বীজের সাথে ১০০ গ্রাম হারে অনুমোদিত অণুজীব সার প্রয়োগ করা যেতে পারে।</p>
                <p className="card-text"><b>বীজ বপন:</b><br />রিলে ফসলের ক্ষেত্রে আমন ধানের পরিপক্কতাকাল এবং জমির রসের পরিমাণের উপর খেসারীর বীজ বপনের সময় নির্ভর করে। এক্ষেত্রে কার্তিক মাস থেকে মধ্য-অগ্রহায়ণ (মধ্য-অক্টোবর থেকে নভেম্বর) পর্যন্ত বীজ বপন করতে হবে। একক ফসলের জন্য মধ্য-কার্তিক থেকে মধ্য-অগ্রহায়ণ (নভেম্বর) মাসে বীজ বপন করতে হবে।</p>
                <p>রিলে ফসল হিসেবে চাষ করলে আমন ধান কাটার প্রায় এক মাস আগে জমিতে পর্যাপ্ত রস থাকা অবস্থায় বীজ ছিটিয়ে বপন করতে হবে। একক ফসল হিসেবেও বীজ ছিটিয়ে বপন করা যায়। তবে সারিতে বপনের ক্ষেত্রে সারির দূরত্ব ৫০ সেমি রাখতে হবে। <br />প্রতি একরে ১৬-১৮ কেজি বীজ লাগে, তবে রিলে ফসলের ক্ষেত্রে বীজের পরিমাণ কিছু বেশি দিতে হয়।</p>
                <p><b>রোগবালাই ব্যবস্থাপনা: <br />রোগের নাম: খেসারীর ডাউনি মিলডিউ রোগ</b></p>
                <p className="card-text"><b>ক্ষতির নমুনা: </b><br />রোগাক্রান্ত খেসারী গাছের পাতা কিছুটা হলদে হয়ে যায়। পাতার নীচে লক্ষ করলে ছত্রাকের অবস্থান খালি চোখেই দেখা যায়। রোগের মাত্রা বেশি হলে পাতা কুঁচকে ও ঝলসে যায়। এ ছত্রাকের জীবাণু মাটিতে ১-২ বৎসর বেঁচে থাকতে পারে।</p>
                <p className="card-text"><b>ব্যবস্থাপনা:</b><br /> রোগ প্রতিরোধী জাত যেমন বারি খেসারী-১ এবং বারি খেসারী-২ চাষ করতে হবে। রিডোমিল এম জেড (০.২%) ১২ দিন পরপর ৩ বার স্প্রে করে এ রোগ দমন করা যায়।</p>
                <p className="card-text"><b>উপযুক্ত জমি ও মাটি:</b><br />দো-আঁশএবং এটেল দো-আঁশ মাটিতে খেসারী ভালো জন্মে। খেসারী প্রধানত বোনা আমন ধান কাটার আগে রিলে ফসল হিসেবে আবাদ করা হয়। সেজন্য জমি চাষের প্রয়োজন হয় না। একক ফসল হিসেবে আবাদের ক্ষেত্রে ৩-৪ টি চাষ  ও মই দিতে হবে।</p>
            </div>
        </div >

    );
};

export default KhesariDalInfo;